




















































import { Vue, Component, Prop } from 'vue-property-decorator'
import Localization from '@/service/localization'

import DeleteProjectDialog from './DeleteProjectDialog.vue'
import EditProjectDialog from './EditProjectDialog.vue'
import AddProjectDialog from './AddProjectDialog.vue'

@Component({
  name: 'c-projects-dialog',

  components: {
    'c-delete-project-dialog': DeleteProjectDialog,
    'c-edit-project-dialog': EditProjectDialog,
    'c-add-project-dialog': AddProjectDialog
  }
})
export default class ProjectsDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop() projects!: any[]

  isAddProject: boolean = false
  isEditProject: boolean = false
  editedProject = {}

  get show (): any {
    return this.value
  }

  set show (value) {
    this.$emit('input', value)
  }

  protected async deleteProject (projectId: string): Promise<void> {
    const answer = await (this.$refs as any).dlg.open()

    if (answer == false) return

    await Localization.deleteProject(projectId)

    this.updateProjects()
  }

  protected updateProjects () {
    this.$emit('update-projects')
  }

  protected editProject (project: any) {
    this.isEditProject = true
    this.editedProject = project
  }
}
